/* tslint:disable: member-ordering */
import { Injectable } from '@angular/core';
import { ActionWithPayload } from '../../app.interfaces';

import { User } from './user.interfaces';

@Injectable()
export class UserActions {
  static LOGOUT = '[User] Logout';
  logout(): ActionWithPayload {
    return {
      type: UserActions.LOGOUT
    };
  }

  static LOGIN = '[User] Login';
  login(username, password): ActionWithPayload {
    return {
      type: UserActions.LOGIN,
      payload: {
        username: username,
        password: password
      }
    };
  }

  static AUTO_LOGIN = '[User] Auto Login';
  autoLogin(id): ActionWithPayload {
    return {
      type: UserActions.AUTO_LOGIN,
      payload: {
        id: id
      }
    };
  }

  static LOGIN_SUCCESS = '[User] Login success';
  loginSuccess(res: User): ActionWithPayload {
    return {
      type: UserActions.LOGIN_SUCCESS,
      payload: res
    };
  }

  static LOGIN_FAIL = '[User] Login fail';
  loginFail(err): ActionWithPayload {
    return {
      type: UserActions.LOGIN_FAIL,
      payload: err
    };
  }

  static LOCK_USER = '[User] Lock user';
  lockUser(): ActionWithPayload {
    return {
      type: UserActions.LOCK_USER
    };
  }

	static SET_LANGUAGE = '[User] Set language';
	setLanguage(lang: string): ActionWithPayload {
		return {
			type: UserActions.SET_LANGUAGE,
			payload: lang
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/logics/user/user.actions.ts